import React, { useState } from "react";
import { firestore } from "../../db/config";
import "../../components/chat/chat.css";
import SendImage from "../../components/chat/send.png";
import firebase from "firebase";
import moment from "moment";
export default function AdminInputChatField() {
  const userRandomNumber = JSON.parse(
    localStorage.getItem("persist:userNumber")
  );

  const getRendomNumber = JSON.parse(userRandomNumber.getChatClickReducer);
  const userId = getRendomNumber.user;
  const [getMessage, setgetMessage] = useState({
    message: "",
  });
  const handleMessageInput = (value, attr) => {
    setgetMessage({
      ...getMessage,
      message: value,
    });
  };
  const handleSubmitMessage = (e) => {
    e.preventDefault();
    if (getMessage.message === "") {
      setgetMessage({
        message: "",
      });
    } else {
      firestore
        .collection("customerMessages")
        .doc(String(userId))
        .collection("messages")

        .add({
          fromUser: "admin",
          read: false,
          to: userId,
          message: getMessage.message,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          delivered: true,
          deliveredTime: moment().format("LT"),
        })
        .then(() => {
          setgetMessage({
            message: "",
          });
        });
    }
  };
  return (
    <div className="input__message__div">
      <form className="input__message__div" onSubmit={handleSubmitMessage}>
        <input
          type="text"
          value={getMessage.message}
          className="input__chat"
          placeholder="Type your message..."
          onChange={(evt) => handleMessageInput(evt.target.value, "message")}
        />
        <button className="chat__button">
          <img src={SendImage} alt="logo" />
        </button>
      </form>
    </div>
  );
}
